import { createContext } from 'react'

export type contextType = {
    isIntersecting: boolean
}

export const Context = createContext<contextType>({ isIntersecting: false })
